<script>
    export let id;
    export let stylist;

    import {createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    function openMe(id) {
        dispatch('display', {
            id:id,
            tabs: 'tabcontent'
        });
    }
</script>

<div class="tab">
    <div><button class="tablinks" on:click={() => openMe(id)}>{stylist.name}</button></div>
</div>
<div id="{stylist.id}" class="tabcontent sixty-five" style="display: none">
    <img src="{stylist.image}" alt="{stylist.name}" />
    <h2 class="lato">{stylist.title}</h2>
    {#if stylist.schedulingLink != ''}
        <a href="{stylist.schedulingLink}" target="_blank"><button>Book an Appointment</button></a>
    {/if}
    <p>{stylist.about}</p>
    <p>{stylist.hours}</p>
</div>